import { CustomerType } from "@origin-digital/platform-enums";
import { BasicJSONSchema, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const voucherId: BasicJSONSchema = {
  description: "hashed fuel voucher id",
  type: "string",
};

export const rewardBarcode_KRAKEN: IMcAppType = {
  name: "rewardBarcode_KRAKEN",
  path: "/my/reward/barcode",
  parameters: {
    required: ["voucherId"],
    properties: { voucherId },
  },
  description: "Reward barcode for fuel discount",
  navFlow: NavFlow.MODAL,
  title: "EG Fuel offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardBarcode",
    customerType: CustomerType.kraken,
  },
};

export const reward_KRAKEN: IMcAppType = {
  name: "reward_KRAKEN",
  path: "/my/reward",
  description: "Reward page for fuel discount",
  navFlow: NavFlow.TAB,
  title: "EG Fuel offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "reward",
    customerType: CustomerType.kraken,
  },
};

export const rewardRewardsAndOffers_KRAKEN: IMcAppType = {
  name: "rewardRewardsAndOffers_KRAKEN",
  path: "/my/reward/rewards-and-offers",
  description: "Rewards & Offers page",
  navFlow: NavFlow.TAB,
  title: "Rewards & Offers",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardRewardsAndOffers",
    customerType: CustomerType.kraken,
  },
};

export const rewardCoffee_KRAKEN: IMcAppType = {
  name: "rewardCoffee_KRAKEN",
  path: "/my/reward/coffee",
  description: "Origin Coffee landing page",
  navFlow: NavFlow.FOCUS,
  title: "7-Eleven Coffee Offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardCoffee",
    customerType: CustomerType.kraken,
  },
};

export const rewardCoffeeBarcode_KRAKEN: IMcAppType = {
  name: "rewardCoffeeBarcode_KRAKEN",
  path: "/my/reward/coffee/barcode",
  description: "Reward barcode for coffee discount",
  navFlow: NavFlow.MODAL,
  title: "7-Eleven Coffee Offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardCoffeeBarcode",
    customerType: CustomerType.kraken,
  },
};

export const rewardMovies_KRAKEN: IMcAppType = {
  name: "rewardMovies_KRAKEN",
  path: "/my/reward/movies",
  description: "Origin Movies landing page",
  navFlow: NavFlow.FOCUS,
  title: "Origin Movies",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardMovies",
    customerType: CustomerType.kraken,
  },
};

export const rewardSlurpee_KRAKEN: IMcAppType = {
  name: "rewardSlurpee_KRAKEN",
  path: "/my/reward/slurpee",
  description: "Origin Slurpee landing page",
  navFlow: NavFlow.FOCUS,
  title: "7-Eleven Slurpee Offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardSlurpee",
    customerType: CustomerType.kraken,
  },
};

export const rewardSlurpeeBarcode_KRAKEN: IMcAppType = {
  name: "rewardSlurpeeBarcode_KRAKEN",
  path: "/my/reward/slurpee/barcode",
  description: "Reward barcode for Slurpee discount",
  navFlow: NavFlow.MODAL,
  title: "7-Eleven Slurpee Offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "rewardSlurpeeBarcode",
    customerType: CustomerType.kraken,
  },
};

export const fuelRewardBarcode_KRAKEN: IMcAppType = {
  name: "fuelRewardBarcode_KRAKEN",
  path: "/my/reward/fuel/barcode",
  parameters: {
    required: ["voucherId"],
    properties: { voucherId },
  },
  description: "Reward barcode for fuel discount",
  navFlow: NavFlow.MODAL,
  title: "EG Fuel offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "fuelRewardBarcode",
    customerType: CustomerType.kraken,
  },
};

export const fuelReward_KRAKEN: IMcAppType = {
  name: "fuelReward_KRAKEN",
  path: "/my/reward/fuel",
  description: "Reward page for fuel discount",
  navFlow: NavFlow.STANDARD,
  title: "EG Fuel offer",
  parent: Tab.REWARDS,
  conditions: {
    intent: "fuelReward",
    customerType: CustomerType.kraken,
  },
};

export const giftmasEntry: IMcAppType = {
  name: "giftmas",
  path: "/my/reward/giftmas",
  description: "Reward page for 12 days of Giftmas entry",
  navFlow: NavFlow.STANDARD,
  title: "12 days of Everyday Rewards",
  parent: Tab.REWARDS,
  conditions: {
    intent: "giftmasRewardEntry",
    customerType: CustomerType.kraken,
  },
};

export const giftmasGame: IMcAppType = {
  name: "giftmasGame",
  path: "/my/reward/giftmas/game",
  description: "Reward game for 12 days of Giftmas",
  navFlow: NavFlow.MODAL,
  title: "12 days of Giftmas",
  parent: Tab.REWARDS,
  conditions: {
    intent: "giftmasRewardGame",
    customerType: CustomerType.kraken,
  },
};

export const freeEnergyHour: IMcAppType = {
  name: "freeEnergyHour",
  path: "/my/reward/feh",
  description: "Energy Happy Hours landing page",
  navFlow: NavFlow.STANDARD,
  title: "Energy Happy Hours",
  parent: Tab.REWARDS,
  conditions: {
    intent: "freeEnergyHour",
    customerType: CustomerType.kraken,
  },
};

export const freeEnergyHourBooking: IMcAppType = {
  name: "freeEnergyHourBooking",
  path: "/my/reward/feh/booking",
  description: "Energy Happy Hours booking page",
  navFlow: NavFlow.FOCUS,
  title: "Book an Energy Happy Hour",
  parent: Tab.REWARDS,
  conditions: {
    intent: "freeEnergyHourBooking",
    customerType: CustomerType.kraken,
  },
};
